import { PageEditorRowType } from 'js/page/PageEditor/PageEditor.types'

// Remove certain fields that the server does not accept
export function sanitizeRows(rows: PageEditorRowType[]) {
    // Remove rowGuid
    const sanitizedRows = rows.map(({ rowGuid: _, columns, ...rest }) => ({
        ...rest,
        columns: columns.map(({ widgets, ...rest }) => ({
            ...rest,
            widgets: widgets.map(
                // Remove widgetGuid
                ({ widgetGuid: _, settings, ...rest }) => ({
                    ...rest,
                    settings: settings?.map(({ links, ...rest }) => ({
                        ...rest,
                        // Remove content from links and set contentGuid
                        links: links?.map(({ content, ...rest }) => ({
                            ...rest,
                            contentGuid: content?.guid,
                        })),
                    })),
                }),
            ),
        })),
    }))
    return sanitizedRows
}
